<template lang="">
    <div>
        
    </div>
</template>
<script>
export default {
    methods:{
	  
	  isMobile() {
		 	this.$router.push('/');
	     }
  },
  created(){
	 this.isMobile();
	
  }
}
</script>
<style lang="">
    
</style>


// WEBPACK FOOTER //
// src/components/Hello.vue